// Stripe Configuration for SheetShed
// Live keys are used in production; test keys in dev/staging.

const ENV = process.env.EXPO_PUBLIC_ENV || 'development';
const isProduction = ENV === 'production';

export const STRIPE_CONFIG = {
  publishableKey: isProduction
    ? (process.env.EXPO_PUBLIC_STRIPE_PUBLISHABLE_KEY || 'pk_live_51SiXFpGzSlj5ZndheBZtRrYrnUoUNobxIjgoixz2H0QRMQry966BOO6AJ6ZOmUOsRYqsp57bgxlGBhVnTEvCbowJ00xgcgtR4m')
    : (process.env.EXPO_PUBLIC_STRIPE_TEST_KEY || 'pk_test_51SiXFtGaraTCWBc66slowpllJIpngzOyuqGm0XJnDvh6gSIXB1cDdC7k1RkdziceybWNIpw7gGaBznjRjVDW7XRA00QoGYE4DA'),
  mode: isProduction ? 'live' : 'sandbox',
  env: ENV,
};

// Stripe IDs — live and test/sandbox
export const STRIPE_IDS = {
  live: {
    productLTD: 'prod_UQIIFYG7H35ttZ',
    priceLTD: 'price_1TRRiMGzSlj5ZndhUbkqphKv',
    productPro: 'prod_UQRz9SiZNnKsTe',
    priceProMonthly: 'price_1TRb5WGzSlj5Zndhq4LbXjbL',
  },
  test: {
    productLTD: 'prod_UQRznYv7rSvcxE',
    priceLTD: 'price_1TRb5mGaraTCWBc68IZ14kdw',
    productPro: 'prod_UQRzLqsDOoQ3K4',
    priceProMonthly: 'price_1TRb5eGaraTCWBc6m9w6w71y',
  },
};

// Convenience: returns the correct IDs based on current env
export const getStripeIds = () => isProduction ? STRIPE_IDS.live : STRIPE_IDS.test;

// Pricing tiers — fallback used when Firestore settings/plans is unavailable
export const PRICING = {
  // Mode 1: Lifetime Deal (Founding Edition)
  LTD: {
    id: 'price_1TRRiMGzSlj5ZndhUbkqphKv',
    testId: 'price_1TRb5mGaraTCWBc68IZ14kdw',
    name: 'SheetShed Lifetime',
    badge: 'Founding Edition',
    price: 14.99,
    currency: 'USD',
    type: 'one_time',
    description: 'One-time payment, lifetime access',
    maxSheets: Infinity,
    shareCreditsPerMonth: Infinity,
    features: [
      'Unlimited sheet storage',
      'Unlimited sharing',
      'All current & future features',
      'Priority support',
      'Founding member badge',
    ],
  },

  // Mode 2: Monthly subscription
  MONTHLY: {
    id: 'price_1TRb5WGzSlj5Zndhq4LbXjbL',
    testId: 'price_1TRb5eGaraTCWBc6m9w6w71y',
    name: 'SheetShed Pro',
    price: 4.99,
    currency: 'USD',
    type: 'subscription',
    interval: 'month',
    description: 'Billed monthly, cancel anytime',
    maxSheets: Infinity,
    shareCreditsPerMonth: 10,
    features: [
      'Unlimited sheet storage',
      '10 share credits / month (roll over)',
      'All pro features',
      'Priority support',
    ],
  },
};

// Free tier limits
export const FREE_TIER = {
  maxSheets: 20,
  maxShares: 5,
  shareCreditsPerMonth: 0,
  features: [
    'View & read sheet music',
    'Page turns',
    'Zoom controls',
    'Dark / sepia mode',
    'Up to 20 sheets',
    'Basic folders',
    'Up to 5 active shares',
  ],
};

export default { STRIPE_CONFIG, STRIPE_IDS, PRICING, FREE_TIER };

